import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

// Sessão isolada por aba: pim_token vive em sessionStorage.
// Migração suave: se existir token legado em localStorage, adota nesta aba e remove o global.
const legado = localStorage.getItem("pim_token");
if (legado && !sessionStorage.getItem("pim_token")) {
  sessionStorage.setItem("pim_token", legado);
  const rl = localStorage.getItem("pim_role");
  if (rl) sessionStorage.setItem("pim_role", rl);
}
localStorage.removeItem("pim_token");
localStorage.removeItem("pim_role");

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=guest, object=logged
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = sessionStorage.getItem("pim_token");
    if (!token) {
      setUser(false);
      setLoading(false);
      return;
    }
    api.get("/auth/me")
      .then((r) => {
        setUser(r.data);
        if (r.data?.role) sessionStorage.setItem("pim_role", r.data.role);
      })
      .catch(() => {
        sessionStorage.removeItem("pim_token");
        sessionStorage.removeItem("pim_role");
        setUser(false);
      })
      .finally(() => setLoading(false));
    // Ao voltar para a aba, revalida a sessão (abas suspensas podem ter sessão expirada)
    const onVisible = () => {
      if (document.visibilityState !== "visible") return;
      const t = sessionStorage.getItem("pim_token");
      if (!t) return;
      api.get("/auth/me").then((r) => {
        if (r.data?.role) sessionStorage.setItem("pim_role", r.data.role);
        setUser((prev) => {
          if (prev && prev.role && r.data?.role && r.data.role !== prev.role) {
            window.location.reload();
          }
          return r.data;
        });
      }).catch(() => {});
    };
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    if (r.data.token) sessionStorage.setItem("pim_token", r.data.token);
    if (r.data.role) sessionStorage.setItem("pim_role", r.data.role);
    setUser(r.data);
    return r.data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    sessionStorage.removeItem("pim_token");
    sessionStorage.removeItem("pim_role");
    localStorage.removeItem("pim_token");
    localStorage.removeItem("pim_role");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
